import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Table from '../Table';
import { BsFilePdf, BsFileEarmarkSpreadsheet, BsLink, BsCopy } from 'react-icons/bs';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import exportPDF from '../Dialogs/exportPDF';


export default function TestKeysSpecialLinkDialog({ open, setOpen, link, onSave }) {
  const [selectedIds, setSelectedIds] = useState([]);
const [copied, setCopied] = useState(false);

const handleCopy = async (text) => {
  await copyToClipboard(text);
  setCopied(true);
  setTimeout(() => setCopied(false), 1500);
};
  const handleSave = () => {
    onSave(selectedIds);
    setOpen(false);
  };

 const copyToClipboard = async (text) => {
  const fullLink = `https://hshop.pl/order/${text}`;
  
  try {
    if (navigator?.clipboard && window.isSecureContext) {
      // nowoczesny sposób
      await navigator.clipboard.writeText(fullLink);
    } else {
      // fallback dla starszych przeglądarek lub HTTP
      const textArea = document.createElement("textarea");
      textArea.value = fullLink;
      textArea.style.position = "fixed";
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
    console.log("✅ Skopiowano:", fullLink);
  } catch (err) {
    console.error("❌ Błąd kopiowania:", err);
  }
};


  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="500px">
      <DialogTitle>Link dla dystrybutora</DialogTitle>
      <DialogContent className="overflow-y-auto max-h-[70vh]">
        <div className="flex flex-col justify-end gap-2">

           
<div className="flex flex-col items-end mt-1 space-y-3">
  {/* Opis */}
  <div className="rounded-lg p-3 ">
   <p className="text-xs text-slate-600 leading-relaxed">
      💡 <span className="font-medium">Uwaga:</span> Podany link powinien otrzymać klient po otrzymaniu zamówienia.
      Pierwszy człon hash jest: <span className="text-slate-700 font-medium">identyfikatorem użytkwonika</span> 
            Drugi człon hash jest: <span className="text-slate-700 font-medium">identyfikatorem klucza w systemie</span> 

  Wysłanie tego linku użyt końcowemu pozwoli poprawnie odłożyć przypisanie do danego dystrybutora jak i późniejsze rozliczenia w systemie.
    </p>
  </div>

  {/* Przycisk */}
 
</div>

        </div>
        <div className="overflow-x-auto">
            {link === '' ? (
          <p>Brak danych do wyświetlenia.</p>
        ) : (
          <div className="flex flex-col items-center gap-1   px-2 py-1 rounded-md ">
        <div className="flex items-center gap-2 bg-slate-50 px-2 py-1 rounded-md border border-slate-200 w-full">
  <BsLink className="text-primary-500 w-4 h-4 shrink-0" />

  {/* Kontener z obcięciem długiego tekstu */}
  <div
    className="text-xs text-slate-600 font-medium truncate overflow-hidden whitespace-nowrap text-ellipsis"
   
    title={`https://hshop.pl/order/${link}/`}
  >
    <span className="text-slate-500">hshop.pl/order/</span>
    {link}
  </div>
</div>

<Button
  className="mt-2"
  size="small"
  color="primary"
  icon={<BsCopy />}
  onClick={() => handleCopy(link)}
>

  
  {copied ? <span>Skopiowano!</span> : <span>Kopiuj</span>}
</Button>
    </div>

        )}
          {/* <Table columns={columns} data={licensesList} /> */}
        </div>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={() => setOpen(false)}>
          Anuluj
        </Button>
      
      </DialogActions>
    </Dialog>
  );
}
